export const port = {
    set(port) {
        if (port != null && typeof port === 'object' && port.id) {
            return port.id;
        }
        return port;
    },
};
//# sourceMappingURL=port.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/attr/port.js
// module id = null
// module chunks = 